import React, { useState , useRef , useEffect } from 'react';
import { ApiUrl } from '../../Constants/Weburl';
import axios from 'axios';

const API = `${ApiUrl}api/deletesubmit`;

// Inga unga real contact details podunga (code la mattum, naan store pannala)
const SUPPORT_EMAIL = 'info@sharesoft.com';
const SUPPORT_PHONE = '+91 7708806434';
const COMPANY_ADDRESS = ['18, APK Main Rd', 'Near CMS Agro Foods,','Avaniyapuram- Madurai – 625012, India'];
const PRIVACY_URL = `${window.location.origin}/pages/privacy-policy`;

// const css = `
// .da-wrap{max-width:720px;margin:0 auto;padding:24px 16px;font-family:Arial,Helvetica,sans-serif;color:#222;line-height:1.6;background:#f4f5f7;min-height:100vh}
// .da-card{background:#fff;padding:28px;border-radius:12px;box-shadow:0 2px 10px rgba(0,0,0,.07);margin-bottom:18px}
// .da-card h1{margin:0 0 8px;font-size:26px}
// .da-card h2{margin:0 0 10px;font-size:20px}
// .da-card ul{padding-left:22px}
// .da-card li{margin:6px 0}
// .da-card label.lbl{display:block;font-weight:bold;margin-top:16px}
// .da-req{color:#c62828;font-size:12px;font-weight:normal;margin-left:6px}
// .da-opt{color:#777;font-size:12px;font-weight:normal;margin-left:6px}
// .da-hint{font-size:13px;color:#666;margin:2px 0 6px}
// .da-card input[type=text],.da-card input[type=email],.da-card input[type=tel],.da-card textarea{
//   width:100%;box-sizing:border-box;padding:12px;border:1px solid #ccc;border-radius:8px;font-size:15px;font-family:inherit}
// .da-card input:focus,.da-card textarea:focus{outline:2px solid #d32f2f33;border-color:#d32f2f}
// .da-check{display:flex;gap:10px;align-items:flex-start;margin-top:18px}
// .da-check input{margin-top:5px}
// .da-btn{width:100%;margin-top:18px;padding:14px;background:#d32f2f;color:#fff;border:0;border-radius:8px;font-size:16px;font-weight:bold;cursor:pointer}
// .da-btn:disabled{opacity:.6;cursor:not-allowed}
// .da-msg{margin-top:14px;padding:12px;border-radius:8px;font-size:14px}
// .da-ok{background:#e8f5e9;color:#2e7d32}
// .da-err{background:#ffebee;color:#c62828}
// .da-card a{color:#d32f2f}
// .da-small{font-size:14px;color:#555}
// `;

// export default function DeleteAccount() {
//   const [form, setForm] = useState({ name: '', email: '', phone: '', reason: '' });
//   const [confirm, setConfirm] = useState(false);
//   const [msg, setMsg] = useState(null); // { text, ok }
//   const [busy, setBusy] = useState(false);

//   const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

//   // const submit = async (e) => {
//   //   e.preventDefault();
//   //   const name = form.name.trim();
//   //   const email = form.email.trim();
//   //   const phone = form.phone.trim();

//   //   if (!name) return setMsg({ text: 'Full name enter pannunga.', ok: false });
//   //   if (!/^\S+@\S+\.\S+$/.test(email)) return setMsg({ text: 'Valid email enter pannunga.', ok: false });
//   //   if (!/^[0-9+\-\s()]{7,20}$/.test(phone)) return setMsg({ text: 'Valid phone number enter pannunga.', ok: false });
//   //   if (!confirm) return setMsg({ text: 'Confirmation checkbox tick pannunga.', ok: false });

//   //   setBusy(true);
//   //   try {
//   //     const r = await axios.post(API, {
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify({ name, email, phone, reason: form.reason, confirm: true }),
//   //     });
//   //     const d = await r.json();
//   //     setMsg({ text: d.message || 'Done', ok: !!d.success });
//   //     if (d.success) {
//   //       setForm({ name: '', email: '', phone: '', reason: '' });
//   //       setConfirm(false);
//   //       window.scrollTo({ top: 0, behavior: 'smooth' });
//   //     }
//   //   } catch (err) {
//   //     setMsg({ text: 'Network error. Please try again.', ok: false });
//   //   }
//   //   setBusy(false);
//   // };
//   const submit = async (e) => {
//   e.preventDefault();
//   const name = form.name.trim();
//   const email = form.email.trim();
//   const phone = form.phone.trim();

//   if (!name) return setMsg({ text: 'Full name enter pannunga.', ok: false });
//   if (!/^\S+@\S+\.\S+$/.test(email)) return setMsg({ text: 'Valid email enter pannunga.', ok: false });
//   if (!/^[0-9+\-\s()]{7,20}$/.test(phone)) return setMsg({ text: 'Valid phone number enter pannunga.', ok: false });
//   if (!confirm) return setMsg({ text: 'Confirmation checkbox tick pannunga.', ok: false });

//   setBusy(true);
//   try {
//     const r = await axios.post(API, {
//       name,
//       email,
//       phone,
//       reason: form.reason,
//       confirm: true,
//     });

//     const d = r.data;
//     setMsg({ text: d.message || 'Done', ok: !!d.success });

//     if (d.success) {
//       setForm({ name: '', email: '', phone: '', reason: '' });
//       setConfirm(false);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   } catch (err) {
//     setMsg({
//       text: err.response?.data?.message || 'Network error. Please try again.',
//       ok: false,
//     });
//   }
//   setBusy(false);
// };

//   return (
//     <div className="da-wrap">
//       <style>{css}</style>

//       <div className="da-card">
//         <h1>Request Account Deletion</h1>
//         <p>
//           This page is available for GoShortz users who wish to request deletion of their account and
//           associated data. You do not need to be logged in to submit this request.
//         </p>
//       </div>

//       <div className="da-card">
//         <h2>Request Account Deletion</h2>
//         <p className="da-small">
//           Please provide the information associated with your GoShortz account so that we can identify
//           and process your request.
//         </p>

//         {msg && <div className={`da-msg ${msg.ok ? 'da-ok' : 'da-err'}`}>{msg.text}</div>}

//         <form onSubmit={submit} noValidate>
//           <label className="lbl" htmlFor="da-name">Full Name <span className="da-req">Required</span></label>
//           <div className="da-hint">Enter the name associated with your GoShortz account.</div>
//           <input id="da-name" type="text" maxLength={100} value={form.name} onChange={set('name')} autoComplete="name" />

//           <label className="lbl" htmlFor="da-email">Registered Email Address <span className="da-req">Required</span></label>
//           <div className="da-hint">Enter the email address associated with your GoShortz account.</div>
//           <input id="da-email" type="email" maxLength={150} value={form.email} onChange={set('email')} autoComplete="email" />

//           <label className="lbl" htmlFor="da-phone">Registered Phone Number <span className="da-req">Required</span></label>
//           <div className="da-hint">Enter the phone number associated with your GoShortz account.</div>
//           <input id="da-phone" type="tel" maxLength={20} value={form.phone} onChange={set('phone')} autoComplete="tel" />

//           <label className="lbl" htmlFor="da-reason">Reason for Deletion <span className="da-opt">Optional</span></label>
//           <div className="da-hint">Tell us why you would like to delete your account.</div>
//           <textarea id="da-reason" rows={4} maxLength={500} value={form.reason} onChange={set('reason')} />

//           <label className="da-check">
//             <input type="checkbox" checked={confirm} onChange={(e) => setConfirm(e.target.checked)} />
//             <span>
//               I confirm that I want to request deletion of my GoShortz account and associated personal data.
//             </span>
//           </label>

//           <button className="da-btn" type="submit" disabled={busy}>
//             {busy ? 'Submitting...' : 'Request Account Deletion'}
//           </button>
//         </form>
//       </div>

//       <div className="da-card">
//         <h2>What Happens After You Submit Your Request?</h2>
//         <p>
//           After receiving your request, GoShortz will verify the request and process the account deletion
//           in accordance with our applicable policies and legal requirements. We will send a verification
//           email to the address you submitted; please confirm it so we can proceed.
//         </p>
//         <p>
//           Once the request has been verified and approved, your account will be permanently deleted{' '}
//           <b>30 days</b> later. Until then, your account remains in its current state.
//         </p>
//         <p>Once the request has been verified and processed:</p>
//         <ul>
//           <li>Your GoShortz account will be deleted.</li>
//           <li>
//             Personal information associated with the account will be deleted where applicable, including
//             your profile, posts and reels, stories, comments, likes, saves, followers and following, and
//             chat messages.
//           </li>
//           <li>Account-related information will no longer be available for normal use through GoShortz.</li>
//           <li>
//             Certain information may be retained where required or permitted by applicable law, regulatory
//             requirements, security, fraud prevention, dispute resolution, or legitimate record-keeping
//             obligations.
//           </li>
//           <li>
//             Where information must be retained, it will be handled in accordance with our Privacy Policy
//             and applicable requirements.
//           </li>
//         </ul>
//         <p>
//           If additional information or verification is required to process your request, the GoShortz team
//           may contact you using the contact information submitted with the request.
//         </p>
//       </div>

//       <div className="da-card">
//         <h2>Important Information About Your Data</h2>
//         <p>
//           GoShortz may process information related to your content (videos, posts, stories), messages, live
//           streams, coin purchases, withdrawals, and other payment-related activities.
//         </p>
//         <p>
//           Because payment and transaction records may be subject to legal, tax, or regulatory retention
//           requirements, some of this information may need to be retained for a specific period even after
//           an account deletion request. Where retention is legally required, the applicable information will
//           not be used for purposes beyond those permitted by the relevant requirements.
//         </p>
//       </div>

//       <div className="da-card">
//         <h2>Before You Request Deletion</h2>
//         <p>Account deletion may affect your ability to:</p>
//         <ul>
//           <li>Access your GoShortz account</li>
//           <li>View your previously posted videos, stories, and followers</li>
//           <li>Access your chat history and conversations</li>
//           <li>Access your coin balance, purchases, or pending withdrawals</li>
//           <li>Use other account-based GoShortz services</li>
//         </ul>
//         <p>
//           Please make sure you understand the consequences of deleting your account before submitting the
//           request.
//         </p>
//       </div>

//       <div className="da-card">
//         <h2>Need Help?</h2>
//         <p>
//           Email: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
//           <br />
//           Phone: {SUPPORT_PHONE}
//         </p>
//         <p className="da-small">
//           <b>GoShortz</b>
//           {COMPANY_ADDRESS.map((l, i) => (
//             <React.Fragment key={i}><br />{l}</React.Fragment>
//           ))}
//         </p>
//         <p className="da-small">
//           For more information about how GoShortz collects, uses, stores, and protects personal
//           information, please review our <a href={PRIVACY_URL}>Privacy Policy</a>.
//         </p>
//       </div>
//     </div>
//   );
// }



const css = `
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
 
.da-page{
  min-height:100vh;
  background:#f3f4f8;
  font-family:'Poppins',sans-serif;
  color:#24364B;
  font-size:16px;
  line-height:1.8;
}
.da-wrap{max-width:820px;margin:0 auto;padding:20px 20px 20px}
 
/* Header */
.da-title{font-size:40px;font-weight:700;color:#1f2023;margin:0 0 4px;line-height:1.2}
.da-subtitle{font-size:19px;color:#5f6368;margin:0 0 20px}
.da-divider{border:0;border-top:1px solid #c9ccd1;margin:0 0 26px}
.da-intro{margin:0 0 28px}
 
/* Cards */
.da-card{
  background:#fff;
  border:1px solid #e6e8ee;
  border-radius:16px;
  padding:32px;
  box-shadow:0 4px 18px rgba(23,43,69,.06);
  margin-bottom:28px;
}
.da-card h2{font-size:22px;font-weight:600;color:#1f2023;margin:0 0 6px}
.da-card-sub{font-size:14.5px;color:#5f6368;margin:0 0 8px}
 
/* Form */
.da-field{margin-top:20px}
.da-label{display:flex;align-items:center;gap:8px;font-weight:600;font-size:15px;color:#1f2023;margin-bottom:2px}
.da-badge{font-size:11px;font-weight:600;padding:1px 9px;border-radius:20px;line-height:1.7}
.da-badge-req{background:#fdecea;color:#c62828}
.da-badge-opt{background:#eef0f4;color:#6b7280}
.da-hint{font-size:13px;color:#6b7280;margin:0 0 8px;line-height:1.5}
 
.da-input,.da-textarea{
  width:100%;box-sizing:border-box;
  padding:13px 15px;
  font-size:15px;font-family:inherit;color:#1f2023;
  background:#fafbfc;
  border:1.5px solid #d8dce3;
  border-radius:12px;
  transition:border-color .15s, box-shadow .15s, background .15s;
}
.da-textarea{resize:vertical;min-height:110px}
.da-input::placeholder,.da-textarea::placeholder{color:#a3a9b5}
.da-input:focus,.da-textarea:focus{
  outline:none;background:#fff;border-color:#d32f2f;box-shadow:0 0 0 4px rgba(211,47,47,.12);
}
.da-input.da-invalid,.da-textarea.da-invalid{border-color:#c62828;background:#fffafa}
.da-error{font-size:13px;color:#c62828;margin-top:6px}
 
.da-check{
  display:flex;gap:12px;align-items:flex-start;
  margin-top:24px;padding:16px;
  background:#fafbfc;border:1.5px solid #e1e4ea;border-radius:12px;
  cursor:pointer;font-size:14.5px;line-height:1.6;
}
.da-check.da-invalid{border-color:#c62828}
.da-check input{width:18px;height:18px;margin-top:4px;accent-color:#d32f2f;flex-shrink:0}
 
.da-btn{
  width:100%;margin-top:24px;padding:15px;
  background:#d32f2f;color:#fff;
  border:0;border-radius:12px;
  font-family:inherit;font-size:16px;font-weight:600;
  cursor:pointer;
  box-shadow:0 6px 16px rgba(211,47,47,.28);
  transition:background .15s, transform .1s, box-shadow .15s;
}
.da-btn:hover:not(:disabled){background:#b71c1c}
.da-btn:active:not(:disabled){transform:translateY(1px)}
.da-btn:disabled{opacity:.65;cursor:not-allowed;box-shadow:none}
 
.da-msg{margin-top:18px;padding:14px 16px;border-radius:12px;font-size:14.5px;line-height:1.6}
.da-ok{background:#e8f5e9;color:#2e7d32;border:1px solid #c8e6c9}
.da-err{background:#fdecea;color:#c62828;border:1px solid #f5c6c2}
 
/* Info sections */
.da-section{margin-bottom:34px}
.da-section h3{font-size:21px;font-weight:600;color:#1f2023;margin:0 0 12px}
.da-section p{margin:0 0 16px}
.da-section ul{margin:0 0 16px;padding-left:26px}
.da-section li{margin-bottom:8px}
.da-section a,.da-footer a{color:#2860D9;text-decoration:underline}
 
.da-highlight{
  display:flex;gap:14px;align-items:flex-start;
  background:#fff;border:1px solid #e6e8ee;border-left:5px solid #d32f2f;
  border-radius:12px;padding:16px 20px;margin:0 0 18px;
}
.da-highlight b{color:#1f2023}
 
.da-warning{
  background:#fff8e6;border:1px solid #f6df9f;border-radius:14px;padding:22px 26px;
}
.da-warning h3{margin-top:0}
.da-warning ul{margin-bottom:12px}
.da-warning p:last-child{margin-bottom:0}
 
/* Footer / contact */
.da-footer{
  background:#fff;border:1px solid #e6e8ee;border-radius:16px;
  padding:32px;box-shadow:0 4px 18px rgba(23,43,69,.06);
}
.da-footer h3{font-size:22px;font-weight:600;color:#1f2023;margin:0 0 4px}
.da-footer-sub{font-size:14.5px;color:#5f6368;margin:0 0 22px}
.da-contact-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:14px}
.da-contact-item{
  display:flex;gap:14px;align-items:center;
  padding:16px 18px;
  background:#fafbfc;border:1px solid #e6e8ee;border-radius:14px;
  text-decoration:none !important;color:inherit;
  transition:border-color .15s, box-shadow .15s, background .15s;
}
a.da-contact-item:hover{border-color:#d32f2f;background:#fff;box-shadow:0 4px 14px rgba(211,47,47,.1)}
.da-contact-item.da-full{grid-column:1 / -1;align-items:flex-start}
.da-icon{
  width:42px;height:42px;flex-shrink:0;
  display:flex;align-items:center;justify-content:center;
  background:#fdecea;color:#d32f2f;border-radius:12px;
}
.da-icon svg{width:20px;height:20px}
.da-contact-label{font-size:12px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.5px;line-height:1.4}
.da-contact-value{font-size:15px;font-weight:500;color:#1f2023;word-break:break-word;line-height:1.5}
.da-privacy-note{
  margin:22px 0 0;padding-top:20px;border-top:1px solid #e6e8ee;
  font-size:14px;color:#5f6368;
}
.da-small{font-size:14px;color:#5f6368}
 
@media (max-width:600px){
  .da-wrap{padding:32px 14px 56px}
  .da-title{font-size:30px}
  .da-subtitle{font-size:16px}
  .da-card,.da-footer{padding:22px 18px;border-radius:14px}
  .da-section h3,.da-footer h3{font-size:18px}
  .da-card h2{font-size:19px}
  .da-page{font-size:15px}
}
`;
 
export default function DeleteAccount() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', reason: '' });
  const [confirm, setConfirm] = useState(false);
  const [errors, setErrors] = useState({});
  const [msg, setMsg] = useState(null); // { text, ok }
  const [busy, setBusy] = useState(false);
  const msgRef = useRef(null);
 
  useEffect(() => {
    if (msg && msgRef.current) {
      msgRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [msg]);
 
  const set = (k) => (e) => {
    setForm({ ...form, [k]: e.target.value });
    if (errors[k]) setErrors({ ...errors, [k]: undefined });
  };
 
  const validate = () => {
    const err = {};
    if (!form.name.trim()) err.name = 'Please enter your full name.';
    if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) err.email = 'Please enter a valid email address.';
    if (!/^[0-9+\-\s()]{7,20}$/.test(form.phone.trim())) err.phone = 'Please enter a valid phone number.';
    if (!confirm) err.confirm = 'Please tick the confirmation checkbox.';
    return err;
  };
 
  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);
 
    const err = validate();
    setErrors(err);
    if (Object.keys(err).length) return;
 
    setBusy(true);
    try {
      const r = await axios.post(API, {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        reason: form.reason,
        confirm: true,
      });
 
      const d = r.data;
      setMsg({ text: d.message || 'Done', ok: !!d.success });
 
      if (d.success) {
        setForm({ name: '', email: '', phone: '', reason: '' });
        setConfirm(false);
        setErrors({});
      }
    } catch (err2) {
      setMsg({
        text: err2.response?.data?.message || 'Network error. Please try again.',
        ok: false,
      });
    }
    setBusy(false);
  };
 
  return (
    <div className="da-page">
      <style>{css}</style>
 
      <div className="da-wrap">
        {/* Header */}
        <h1 className="da-title">Request Account Deletion</h1>
        <div className="da-subtitle">GoShortz account &amp; data deletion</div>
        <hr className="da-divider" />
 
        <p className="da-intro">
          This page is available for GoShortz users who wish to request deletion of their account and
          associated data. You do not need to be logged in to submit this request.
        </p>
 
        {/* Form */}
        <div className="da-card">
          <h2>Submit Your Request</h2>
          <p className="da-card-sub">
            Please provide the information associated with your GoShortz account so that we can identify
            and process your request.
          </p>
 
          <form onSubmit={submit} noValidate>
            <div className="da-field">
              <label className="da-label" htmlFor="da-name">
                Full Name <span className="da-badge da-badge-req">Required</span>
              </label>
              <div className="da-hint">Enter the name associated with your GoShortz account.</div>
              <input
                id="da-name"
                type="text"
                maxLength={100}
                placeholder="Your full name"
                className={`da-input ${errors.name ? 'da-invalid' : ''}`}
                value={form.name}
                onChange={set('name')}
                autoComplete="name"
              />
              {errors.name && <div className="da-error">{errors.name}</div>}
            </div>
 
            <div className="da-field">
              <label className="da-label" htmlFor="da-email">
                Registered Email Address <span className="da-badge da-badge-req">Required</span>
              </label>
              <div className="da-hint">Enter the email address associated with your GoShortz account.</div>
              <input
                id="da-email"
                type="email"
                maxLength={150}
                placeholder="you@example.com"
                className={`da-input ${errors.email ? 'da-invalid' : ''}`}
                value={form.email}
                onChange={set('email')}
                autoComplete="email"
              />
              {errors.email && <div className="da-error">{errors.email}</div>}
            </div>
 
            <div className="da-field">
              <label className="da-label" htmlFor="da-phone">
                Registered Phone Number <span className="da-badge da-badge-req">Required</span>
              </label>
              <div className="da-hint">Enter the phone number associated with your GoShortz account.</div>
              <input
                id="da-phone"
                type="tel"
                maxLength={20}
                placeholder="+91 98765 43210"
                className={`da-input ${errors.phone ? 'da-invalid' : ''}`}
                value={form.phone}
                onChange={set('phone')}
                autoComplete="tel"
              />
              {errors.phone && <div className="da-error">{errors.phone}</div>}
            </div>
 
            <div className="da-field">
              <label className="da-label" htmlFor="da-reason">
                Reason for Deletion <span className="da-badge da-badge-opt">Optional</span>
              </label>
              <div className="da-hint">Tell us why you would like to delete your account.</div>
              <textarea
                id="da-reason"
                maxLength={500}
                placeholder="Share your reason (optional)"
                className="da-textarea"
                value={form.reason}
                onChange={set('reason')}
              />
            </div>
 
            <label className={`da-check ${errors.confirm ? 'da-invalid' : ''}`}>
              <input
                type="checkbox"
                checked={confirm}
                onChange={(e) => {
                  setConfirm(e.target.checked);
                  if (errors.confirm) setErrors({ ...errors, confirm: undefined });
                }}
              />
              <span>
                I confirm that I want to request deletion of my GoShortz account and associated personal
                data.
              </span>
            </label>
            {errors.confirm && <div className="da-error">{errors.confirm}</div>}
 
            <button className="da-btn" type="submit" disabled={busy}>
              {busy ? 'Submitting...' : 'Request Account Deletion'}
            </button>
 
            {msg && (
              <div ref={msgRef} className={`da-msg ${msg.ok ? 'da-ok' : 'da-err'}`}>
                {msg.text}
              </div>
            )}
          </form>
        </div>
 
        {/* What happens next */}
        <div className="da-section">
          <h3>What Happens After You Submit Your Request?</h3>
          <p>
            After receiving your request, GoShortz will verify the request and process the account deletion
            in accordance with our applicable policies and legal requirements. We will send a verification
            email to the address you submitted; please confirm it so we can proceed.
          </p>
 
          <div className="da-highlight">
            <div>
              Once the request has been verified and approved, your account will be permanently deleted{' '}
              <b>30 days</b> later. Until then, your account remains in its current state.
            </div>
          </div>
 
          <p>Once the request has been verified and processed:</p>
          <ul>
            <li>Your GoShortz account will be deleted.</li>
            <li>
              Personal information associated with the account will be deleted where applicable, including
              your profile, posts and reels, stories, comments, likes, saves, followers and following, and
              chat messages.
            </li>
            <li>Account-related information will no longer be available for normal use through GoShortz.</li>
            <li>
              Certain information may be retained where required or permitted by applicable law, regulatory
              requirements, security, fraud prevention, dispute resolution, or legitimate record-keeping
              obligations.
            </li>
            <li>
              Where information must be retained, it will be handled in accordance with our Privacy Policy
              and applicable requirements.
            </li>
          </ul>
          <p>
            If additional information or verification is required to process your request, the GoShortz team
            may contact you using the contact information submitted with the request.
          </p>
        </div>
 
        {/* Data info */}
        <div className="da-section">
          <h3>Important Information About Your Data</h3>
          <p>
            GoShortz may process information related to your content (videos, posts, stories), messages, live
            streams, coin purchases, withdrawals, and other payment-related activities.
          </p>
          <p>
            Because payment and transaction records may be subject to legal, tax, or regulatory retention
            requirements, some of this information may need to be retained for a specific period even after
            an account deletion request. Where retention is legally required, the applicable information will
            not be used for purposes beyond those permitted by the relevant requirements.
          </p>
        </div>
 
        {/* Warning */}
        <div className="da-section da-warning">
          <h3>Before You Request Deletion</h3>
          <p>Account deletion may affect your ability to:</p>
          <ul>
            <li>Access your GoShortz account</li>
            <li>View your previously posted videos, stories, and followers</li>
            <li>Access your chat history and conversations</li>
            <li>Access your coin balance, purchases, or pending withdrawals</li>
            <li>Use other account-based GoShortz services</li>
          </ul>
          <p>
            Please make sure you understand the consequences of deleting your account before submitting the
            request.
          </p>
        </div>
 
        {/* Contact */}
        <div className="da-footer">
          <h3>Need Help?</h3>
          <p className="da-footer-sub">Our team is happy to help with your account deletion request.</p>
 
          <div className="da-contact-grid">
            <a className="da-contact-item" href={`mailto:${SUPPORT_EMAIL}`}>
              <span className="da-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="M3 7l9 6 9-6" />
                </svg>
              </span>
              <span>
                <div className="da-contact-label">Email</div>
                <div className="da-contact-value">{SUPPORT_EMAIL}</div>
              </span>
            </a>
 
            <a className="da-contact-item" href={`tel:${String(SUPPORT_PHONE).replace(/[^+\d]/g, '')}`}>
              <span className="da-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />
                </svg>
              </span>
              <span>
                <div className="da-contact-label">Phone</div>
                <div className="da-contact-value">{SUPPORT_PHONE}</div>
              </span>
            </a>
 
            <div className="da-contact-item da-full">
              <span className="da-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              <span>
                <div className="da-contact-label">Company</div>
                <div className="da-contact-value">
                  <b>GoShortz</b>
                  {COMPANY_ADDRESS.map((l, i) => (
                    <React.Fragment key={i}>
                      <br />
                      {l}
                    </React.Fragment>
                  ))}
                </div>
              </span>
            </div>
          </div>
 
          <p className="da-privacy-note">
            For more information about how GoShortz collects, uses, stores, and protects personal
            information, please review our <a href={PRIVACY_URL}>Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>
  );
}